import React from 'react';

class Myjob extends React.Component {
    render() {
        return null;
    }
}

export default Myjob;
